// extracted by mini-css-extract-plugin
export default {"sideBar":"SideBar_sideBar__IJOXi","logo":"SideBar_logo__-mRZd","expandIcon":"SideBar_expandIcon__RaKWL","buttonContainer":"SideBar_buttonContainer__H66Pm","btn":"SideBar_btn__NZUuq"};